export const COMPILER_ERROR_TYPES = {
  SYNTAX_ERROR: { id: "SYNTAX_ERROR", displayName: "Syntax Error" },
  INVALID_ATTRIBUTE_DESCRIPTION: { id: "INVALID_ATTRIBUTE_DESCRIPTION", displayName: "Invalid Attribute Description" },
  INVALID_COMMAND_ARGUMENT_COUNT: { id: "INVALID_COMMAND_ARGUMENT_COUNT", displayName: "Invalid Command Arguments" },
  INVALID_ALIAS_ARGUMENT: { id: "INVALID_ALIAS_ARGUMENT", displayName: "Invalid Alias Argument" },
  MISSING_RELATIONSHIP: { id: "MISSING_RELATIONSHIP", displayName: "Missing Relationship" },
  MISSING_CONCLUSION: { id: "MISSING_CONCLUSION", displayName: "Missing Conclusion" },
  INVALID_ARGUMENT: { id: "INVALID_ARGUMENT", displayName: "Invalid Argument" },
  INVALID_SCOPE: { id: "INVALID_SCOPE", displayName: "Invalid Scope" },
  INVALID_CONTACT_METADATA: { id: "INVALID_CONTACT_METADATA", displayName: "Invalid Contact Metadata" },
  DUPLICATE_PROVEN_ATTRIBUTE: { id: "DUPLICATE_PROVEN_ATTRIBUTE", displayName: "Duplicate Proven Attribute" },
  INVALID_DECISION_TABLE: { id: "INVALID_DECISION_TABLE", displayName: "Invalid Decision Table" },
  INVALID_DERIVED_TABLE: { id: "INVALID_DERIVED_TABLE", displayName: "Invalid Derived Table" },
  INTERNAL_ERROR: { id: "INTERNAL_ERROR", displayName: "Internal Error" },
} as const;

export type CompilerErrorType = keyof typeof COMPILER_ERROR_TYPES;
export type CompilerErrorTypeInfo = (typeof COMPILER_ERROR_TYPES)[CompilerErrorType];
